import React from "react";
import { useProductsContext } from "../context/Context";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Logo = "https://i.ibb.co/MMg1kXh/maruf-img-3.jpg";

const Navbar = () => {
  const { openSidebar, isSidebarOpen, CursorBig, CursorSmall } =
    useProductsContext();

  return (
    <NavbarStyle>
      <nav className={`${isSidebarOpen ? "nav active-sidebar" : "nav"}`}>
        <div className="navbar row">
          <div className="nav__logo">
            <Link to="/">
              <img src={Logo} alt="maruf" />
            </Link>
          </div>
          <div>
            <div className="bars-bg"></div>
            <button
              className="nav__bars link"
              onClick={openSidebar}
              onMouseOver={CursorBig}
              onMouseOut={CursorSmall}
            >
              <span className="nav__bars--1"></span>
              <span className="nav__bars--2"></span>
              <span className="nav__bars--3"></span>
            </button>
          </div>
        </div>
      </nav>
    </NavbarStyle>
  );
};

export default Navbar;

const NavbarStyle = styled.div``;
